<template>
<div class="container-fluid">

    <div class="jumbotron">
  <h1 class="display-4">POIZON PRODUCTS PUSH ZONE</h1>
  <p class="lead">{{ msg }}</p>
  <hr class="my-4">
  <p v-if="response">
    <ul id="example-1">
  <li v-for="item in response" :key="item.requestNo">
    {{ item }}
  </li>
</ul>
    
  </p>
  <button v-if="company.Id == 26 && !bt_spinner2" :disabled="bt_spinner1" @click="pushProducts('pushAll')" class="btn btn-primary" type="button">
    PUSH ALL PRODUCTS
    <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">    
    </span>
  </button>
  <button v-if="company.Id == 26 && !bt_spinner1" :disabled="bt_spinner2" @click="pushProducts('pushIncrement')" class="btn btn-secondary ml-3" type="button">
    PUSH INCREMENT PRODUCTS
    <span v-if="bt_spinner2" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">    
    </span>
  </button>
</div>

</div>

</template>

<script>
import axios              from 'axios'

import { mapGetters }     from 'vuex';


export default {
  
  data () {
    return {


        bt_spinner1 : false,
        bt_spinner2 : false,
        response   : [],
        msg        : ''
        

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),     

  },
      
  mounted()
  {
    

    //this.getData()

  },
  created()  
  {

   
  }, 
  methods: 
    {
      
           
     async pushProducts(type)
      {
        this.msg        = 'Sincronizzazione prodotti in esecuzione ...'
        this.response   = []
        this.bt_spinner1 = type == 'pushAll' ? true : false
        this.bt_spinner2 = type == 'pushIncrement' ? true : false

        const timeout   = 0
        let url               = ''
        if(this.company.Id == 26)
          {
            url    = process.env.VUE_APP_ROOT_API1 + 'sync/poizon/'+ type + '/26' 
          }
          else
          {
              url   =  ''
          }
              if(url)  
              {
               
                axios({
                url      : url,
                method   : "get",
                timeout  : timeout
                
                }).then(res => {

                    console.log('PUSH ZONE RESPONSE',res.data)
                    this.response = res.data

                }).catch(error => {
                    console.log('PUSH ZONE RESPONSE ERROR',error)
                    if (error.response) {
                    
                        console.log(error.response.status);
                        console.log(error.response.data);
      
                        this.response = error.response.data
                        
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      this.response.request

      
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      this.response.message
      
    }
    



                    
                }).finally(() =>{
                    this.msg = ''
                    this.bt_spinner1 = false
                    this.bt_spinner2 = false
                }
                )
                
                
              }
                
                
                    
        }
        
















    
      },
    
    
      


        
    
        

      
    
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 500px;
overflow : auto;
}
.table-wrapper-scroll-y {
  display  : block;
}
a{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  color       : red
}

.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }

    .bold
    {
        font-weight  : bold;
    }
    input[type=number] {
    border: 1px solid;
 
}
</style>